import { Component, Input, Inject } from '@angular/core';
import { Appointment } from '../../../shared/models/appointment.model';
import { Patient } from '../../../shared/models/patient.model';

import * as moment from 'moment';

@Component({
  selector: 'appointment',
  template: require('./appointment.component.html'),
  styles: [require('./appointment.component.scss')]
})
export class AppointmentComponent {
  @Input() appointment: Appointment = {} as Appointment;
  @Input() patient: Patient;

  constructor(
    @Inject('$translate') private $translate,
  ) {}

  get formattedDate(): string {
    return moment(this.appointment.availability.startTime).format(this.$translate.instant('date_format.dayname_day_month_and_year_and_time'));
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/appointments/appointment/appointment.component.ts